/* eslint-disable react/prop-types */
import React from 'react'
import config from 'config'

import { isFeatureEnabled } from '../../services/feature-check-service'

class JourneyBuilderIframe extends React.Component {
  constructor(props) {
    super(props)
    this.iframeURL = `${config.casaWebAppUrl}/journey/${props.subRoute}`
  }
  render() {
    return !isFeatureEnabled('journeyBuilder') ? (
      <iframe src={this.iframeURL} style={{
        flex: 1,
        height: '100vh',
        width: '100%'
      }} />
    ) : (
      <div>This Page doesn't exist!</div>
    )
  }
}

export default JourneyBuilderIframe



// WEBPACK FOOTER //
// ./src/routes/JourneyBuilder/JourneyBuilderIframe.js